// src/units/unitsApi.ts
import { apiClient } from "@maat/api-base";
var unitsApi = {
  /** The room-type page's read; a pool's room is a 404 (it has `roomsApi.getRoom`). */
  getUnit: async (unitId) => {
    return apiClient.get(`/main/api/units/${unitId}`);
  },
  createUnit: async (propertyId, body) => {
    return apiClient.post(`/main/api/properties/${propertyId}/units`, body);
  },
  /**
   * A unit, its rooms (two or more names make a pool) and its first rate plan in one
   * transaction. Needs `properties.publish`; 503 while the multi-unit gate is off.
   */
  createRoomType: async (propertyId, body) => {
    return apiClient.post(`/main/api/properties/${propertyId}/room-types`, body);
  },
  updateUnit: async (unitId, body) => {
    return apiClient.put(`/main/api/units/${unitId}`, body);
  },
  deleteUnit: async (unitId) => {
    return apiClient.delete(`/main/api/units/${unitId}`);
  },
  createListing: async (unitId, body) => {
    return apiClient.post(`/main/api/units/${unitId}/listings`, body);
  }
};

export {
  unitsApi
};
